var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v(_vm._s(_vm.$t("common.devices"))),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "ring-card__header-buttons" },
          [
            _c("RefreshButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.getDeviceRegistries()
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-content device-list" },
      [
        _vm.errorMessage
          ? _c("el-alert", {
              attrs: {
                title: "Customer Devices",
                type: "warning",
                closable: false,
                description: _vm.errorMessage,
                "show-icon": "",
              },
            })
          : _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: !_vm.customerId || _vm.loading,
                    expression: "!customerId || loading",
                  },
                ],
                staticStyle: { "min-height": "100px", margin: "0px 0px 15px" },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "18px",
                      display: "inline-flex",
                      margin: "0px 10px 15px",
                    },
                  },
                  [_vm._v(" Location: ")]
                ),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticStyle: { "max-width": "320px" },
                    attrs: { placeholder: "Customer Locations" },
                    on: {
                      change: function ($event) {
                        return _vm.getDeviceRegistries()
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prefix",
                        fn: function () {
                          return [
                            _vm.isResidentialLocation(_vm.selectedLocation)
                              ? _c("i", { staticClass: "el-icon-s-home" })
                              : _c("i", {
                                  staticClass: "el-icon-office-building",
                                }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.selectedLocation,
                      callback: function ($$v) {
                        _vm.selectedLocation = $$v
                      },
                      expression: "selectedLocation",
                    },
                  },
                  [
                    _vm._v(" "),
                    _vm._l(_vm.accountLocations, function (item, index) {
                      return _c("el-option", {
                        key: item.value + "-" + index,
                        attrs: { label: item.label, value: item },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function () {
                                return [
                                  _vm.isResidentialLocation(item)
                                    ? _c("i", { staticClass: "el-icon-s-home" })
                                    : _c("i", {
                                        staticClass: "el-icon-office-building",
                                      }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.label))]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.rbacEnabled
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "ring-card-action-box__text ring-card-action-box__description",
                        staticStyle: { margin: "0px 10px 15px" },
                        attrs: { id: "role-description" },
                      },
                      [_vm._v(_vm._s(_vm.getCustomerLocationRoleDescription()))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tableReady
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        staticClass: "table__header-subtitles",
                        attrs: {
                          "row-class-name": "device-table-row-style",
                          "cell-class-name": "device-table-cell-style",
                          data: _vm.filteredDevices,
                          "highlight-current-row": false,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { "min-width": "90", label: "Device" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "center" },
                                      },
                                      [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "top-start",
                                              width: "200",
                                              trigger: "hover",
                                            },
                                          },
                                          [
                                            scope.row.deleted_at !== undefined
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "offline-device__icon",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Deleted on " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            scope.row
                                                              .deleted_at,
                                                            "MMMM Do YYYY, h:mm a"
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : scope.row.deactivated_at !==
                                                undefined
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "offline-device__icon",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Deactivated on " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            scope.row
                                                              .deactivated_at,
                                                            "MMMM Do YYYY, h:mm a"
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "online-device__icon",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Activated on " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            scope.row
                                                              .created_at,
                                                            "MMMM Do YYYY, h:mm a"
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "reference" },
                                                slot: "reference",
                                              },
                                              [
                                                scope.row.deleted_at !==
                                                undefined
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "offline-device__icon",
                                                      },
                                                      [_vm._v("Deleted")]
                                                    )
                                                  : scope.row.deactivated_at !==
                                                    undefined
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "offline-device__icon",
                                                      },
                                                      [_vm._v("Deactivated")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "online-device__icon",
                                                      },
                                                      [_vm._v("Active")]
                                                    ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("DeviceImage", {
                                          attrs: { device: scope.row },
                                        }),
                                        _vm._v(" "),
                                        _vm.statuses.loading
                                          ? _c("i", {
                                              staticClass: "el-icon-loading",
                                            })
                                          : _vm.isFirstClassDevice(scope.row)
                                          ? _c("span", [
                                              _vm.get(
                                                _vm.statuses.devices[
                                                  scope.row.doorbot_id
                                                ],
                                                "connected",
                                                false
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "online-device__icon",
                                                    },
                                                    [_vm._v("Online")]
                                                  )
                                                : _vm.statuses.devices[
                                                    scope.row.doorbot_id
                                                  ] === undefined
                                                ? _c("span")
                                                : _vm.get(
                                                    _vm.statuses.devices[
                                                      scope.row.doorbot_id
                                                    ],
                                                    "service"
                                                  ) === "DHS" &&
                                                  _vm.get(
                                                    _vm.statuses.devices[
                                                      scope.row.doorbot_id
                                                    ],
                                                    "connected"
                                                  ) === null
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "offline-device__icon",
                                                    },
                                                    [_vm._v("N/A")]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "offline-device__icon",
                                                    },
                                                    [_vm._v("Offline")]
                                                  ),
                                            ])
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            131838452
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "min-width": "500" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "padding-left": "10px",
                                          "text-align": "justify",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "border-bottom": "solid 1px #ddd",
                                              "margin-bottom": "10px",
                                              "padding-bottom": "10px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(scope.row.name) +
                                                "\n                "
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { color: "#999" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm.product(scope.row)
                                                        .description ||
                                                        scope.row.type
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-column" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  position: "relative",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      target: "_self",
                                                      underline: false,
                                                      href: _vm.deviceRoute(
                                                        scope.row
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.deviceLinkText(
                                                            scope.row
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.hasRingSolutionsUnavailable(
                                              scope.row
                                            )
                                              ? _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "ring-solution-unavailable",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getRingSolutionsUrlUnavailableDescription(
                                                            scope.row
                                                              .ring_solutions_url_unavailable
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.hasRingSolutionsUrl(scope.row)
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("AlarmDesktopLink", {
                                                      attrs: {
                                                        url: scope.row
                                                          .ring_solutions_url,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm.warranty.loading
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-loading",
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "warranty-status flex flex-row",
                                                      staticStyle: {
                                                        "align-items": "center",
                                                        "margin-left": "-1em",
                                                      },
                                                    },
                                                    [
                                                      _vm.delayedFulfillmentEnabled
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex-none",
                                                              staticStyle: {
                                                                "max-width":
                                                                  "fit-content",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "el-alert",
                                                                {
                                                                  staticClass:
                                                                    "coverage-alerts",
                                                                  attrs: {
                                                                    title:
                                                                      "Fulfillment",
                                                                    closable: false,
                                                                    type: "info",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "StatusTag",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-size":
                                                                            "13px",
                                                                        },
                                                                      attrs: {
                                                                        "is-error":
                                                                          _vm.getFulfillmentStatus(
                                                                            _vm
                                                                              .eligibility[
                                                                              scope
                                                                                .row
                                                                                .device_id
                                                                            ]
                                                                              .isDelayedFulfillment
                                                                          ) !==
                                                                          "Standard",
                                                                        "disable-tip":
                                                                          !_vm.showFulfillmentReason(
                                                                            _vm
                                                                              .eligibility[
                                                                              scope
                                                                                .row
                                                                                .device_id
                                                                            ]
                                                                              .isDelayedFulfillment
                                                                          ),
                                                                        "status-message":
                                                                          _vm.getFulfillmentStatus(
                                                                            _vm
                                                                              .eligibility[
                                                                              scope
                                                                                .row
                                                                                .device_id
                                                                            ]
                                                                              .isDelayedFulfillment
                                                                          ),
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "popover-content",
                                                                              fn: function () {
                                                                                return [
                                                                                  _c(
                                                                                    "FulfillmentReasons",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          reason:
                                                                                            (_vm
                                                                                              .eligibility[
                                                                                              scope
                                                                                                .row
                                                                                                .device_id
                                                                                            ] &&
                                                                                              _vm
                                                                                                .eligibility[
                                                                                                scope
                                                                                                  .row
                                                                                                  .device_id
                                                                                              ]
                                                                                                .delayedFulfillmentReason) ||
                                                                                            "",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              },
                                                                              proxy: true,
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.delayedFulfillmentEnabled
                                                        ? _c("div", {
                                                            staticClass:
                                                              "custom-divider",
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex-none",
                                                          staticStyle: {
                                                            "max-width":
                                                              "fit-content",
                                                            "margin-left":
                                                              "5px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-alert",
                                                            {
                                                              staticClass:
                                                                "coverage-alerts",
                                                              attrs: {
                                                                title:
                                                                  "Warranty",
                                                                closable: false,
                                                                type: "info",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex-col",
                                                                },
                                                                [
                                                                  _c(
                                                                    "WithVariable",
                                                                    {
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "default",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var w =
                                                                                  ref.w
                                                                                if (
                                                                                  w ===
                                                                                  void 0
                                                                                )
                                                                                  w =
                                                                                    _vm.deviceWarranty(
                                                                                      scope.row
                                                                                    )
                                                                                return [
                                                                                  _c(
                                                                                    "StatusTag",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          "font-size":
                                                                                            "13px",
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          "status-message":
                                                                                            w.status,
                                                                                          "is-error":
                                                                                            !w.in_warranty,
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "popover-content",
                                                                                              fn: function () {
                                                                                                return [
                                                                                                  _c(
                                                                                                    "WarrantyInfo",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          data: w,
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                ]
                                                                                              },
                                                                                              proxy: true,
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "custom-divider",
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex-none",
                                                          staticStyle: {
                                                            "max-width":
                                                              "fit-content",
                                                            "margin-left":
                                                              "5px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-alert",
                                                            {
                                                              staticClass:
                                                                "coverage-alerts",
                                                              attrs: {
                                                                title:
                                                                  "Eligibility",
                                                                closable: false,
                                                                type: "info",
                                                              },
                                                            },
                                                            [
                                                              _vm.eligibility[
                                                                scope.row
                                                                  .device_id
                                                              ]
                                                                ? _c(
                                                                    "EligibilityTags",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-size":
                                                                            "13px",
                                                                        },
                                                                      attrs: {
                                                                        eligibility:
                                                                          _vm
                                                                            .eligibility[
                                                                            scope
                                                                              .row
                                                                              .device_id
                                                                          ],
                                                                      },
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1854724424
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "min-width": "140", label: "Location" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("truncate")(
                                            _vm.get(
                                              scope.row,
                                              "location.name",
                                              ""
                                            ),
                                            20
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3853803781
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "min-width": "220", label: "Users" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-col items-start",
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm._l(
                                          scope.row.authorized_users.owners,
                                          function (user) {
                                            return _c("div", { key: user.id }, [
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("truncate")(
                                                        user.email,
                                                        30
                                                      )
                                                    )
                                                ),
                                              ]),
                                            ])
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          scope.row.authorized_users.users,
                                          function (user) {
                                            return _c("div", { key: user.id }, [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("truncate")(
                                                        user.email,
                                                        30
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3827341547
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "min-width": "160", label: "Health" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _vm.isFirstClassDevice(scope.row)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flex items-start",
                                              },
                                              [
                                                _c("DiagnosticHealth", {
                                                  attrs: {
                                                    popover: true,
                                                    "report-time-stamp":
                                                      _vm.get(
                                                        scope.row,
                                                        "last_status_report.timestamp",
                                                        ""
                                                      ),
                                                    diagnostic: _vm.get(
                                                      scope.row,
                                                      "health_information.status_report",
                                                      []
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _vm.supportsBitrateInfo(scope.row)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex flex-col",
                                                  },
                                                  [
                                                    _c(
                                                      "BitrateInfoPopover",
                                                      {
                                                        staticClass:
                                                          "flex-grow",
                                                        staticStyle: {
                                                          "padding-bottom":
                                                            "7px",
                                                        },
                                                        attrs: {
                                                          device: scope.row,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Bitrate\n                "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-row",
                                                      },
                                                      [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            staticClass:
                                                              "flex-grow",
                                                            attrs: {
                                                              content:
                                                                "Device offline or unavailable",
                                                              disabled:
                                                                _vm.isDeviceOffline(
                                                                  scope.row
                                                                ) === false,
                                                              placement:
                                                                "bottom",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "ThroughputTest",
                                                              {
                                                                attrs: {
                                                                  placement:
                                                                    "left",
                                                                  "device-kind":
                                                                    scope.row
                                                                      .type,
                                                                },
                                                                on: {
                                                                  execute:
                                                                    function (
                                                                      test_type,
                                                                      done
                                                                    ) {
                                                                      return _vm.executeTest(
                                                                        scope.row,
                                                                        test_type,
                                                                        done
                                                                      )
                                                                    },
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function () {
                                                                          return [
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    "min-width":
                                                                                      "100%",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    disabled:
                                                                                      _vm.isDeviceOffline(
                                                                                        scope.row
                                                                                      ),
                                                                                    plain:
                                                                                      "",
                                                                                    size: "mini",
                                                                                    type: "info",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                          Iperf Test\n                        "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                        proxy: true,
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "SummaryReportPopover",
                                                          {
                                                            attrs: {
                                                              title:
                                                                "Iperf Test Result",
                                                              "iperf-only": true,
                                                              report:
                                                                _vm.tTest
                                                                  .devices[
                                                                  scope.row
                                                                    .doorbot_id
                                                                ].result,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "el-tag",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "margin-left":
                                                                                "3px",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              size: "medium",
                                                                              type: "info",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "font-awesome-icon",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  display:
                                                                                    "inline-block",
                                                                                  padding:
                                                                                    "0 5px 0 5px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  icon: _vm.faInfo,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    : undefined
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "min-width": "100", label: "Power" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _vm.isFirstClassDevice(scope.row)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex items-start",
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.power_source)
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    : undefined
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "min-width": "100", label: "Network" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _vm.isFirstClassDevice(scope.row)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex items-start",
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.networkName(scope.row)
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    : undefined
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: { "min-width": "120" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.troubleshooting.loading
                                        ? _c("i", {
                                            staticClass: "el-icon-loading",
                                          })
                                        : _c("Tags", {
                                            attrs: {
                                              slot: "content",
                                              "tags-direction": "col",
                                              list: _vm.dynamicTags(scope.row),
                                            },
                                            slot: "content",
                                          }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3646954540
                            ),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v("\n            Tag \n            ("),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "text-decoration": "none",
                                    color: "#1998d5",
                                  },
                                  attrs: {
                                    href: "https://ring.com/support/internal/articles/per08/tags-in-neighbor-console-and-neighbor-dashboard",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Details\n            "
                                  ),
                                ]
                              ),
                              _vm._v(")\n          "),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("el-pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pagination.show,
                      expression: "pagination.show",
                    },
                  ],
                  staticStyle: { padding: "25px 0 20px" },
                  attrs: {
                    background: "",
                    "hide-on-single-page": true,
                    "current-page": _vm.pagination.currentPage,
                    "page-size": _vm.pagination.size,
                    layout: "prev, pager, next",
                    total: _vm.pagination.total,
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.pagination, "currentPage", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.pagination, "currentPage", $event)
                    },
                    "current-change": _vm.handlePageChange,
                  },
                }),
              ],
              1
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }